import React from 'react';
import { Container } from './Container';
export function Values() {
  const pillars = [{
    num: '01',
    title: 'Achieve It',
    desc: "Results aren't a bonus — they're the baseline. We set the target, map the path, and execute without excuses. If it's on the board, it gets done."
  }, {
    num: '02',
    title: 'Believe It',
    desc: 'Every great campaign starts before the world is watching. We invest in the vision early, bring full conviction to the work, and never halfway anything.'
  }, {
    num: '03',
    title: 'Innovate It',
    desc: "We don't follow the playbook — we write new ones. Fresh angles, unexpected moves, and creative that earns attention instead of buying it."
  }, {
    num: '04',
    title: 'Elevate It',
    desc: 'Good is the starting point. We push until the work rises above the moment — and leaves something lasting behind.'
  }];
  return <section className="border-b border-brand-gray300 bg-brand-black py-[clamp(70px,10vw,140px)] text-brand-white" data-id="element-228" data-mp="36zljzcipankk">
      <Container data-id="element-229" data-mp="3r5u6po3lry4j">
        <div className="mb-[clamp(40px,6vw,80px)] flex flex-wrap items-end justify-between gap-[40px]" data-id="element-230" data-mp="3w2syhzzsnszk">
          <div className="self-start" data-id="element-231" data-mp="4wrkpjog2la8">
            <span className="font-mono text-[12px] uppercase tracking-[0.18em] text-white/60" data-id="element-232" data-mp="4vqd5p6n0gx9">
              03 · The formula
            </span>
            <p className="mt-5 max-w-[30ch] text-[16px] leading-[1.5] text-white/80" data-id="element-233" data-mp="dx7oku93nufm">
              This is how we work. Every project. Every time.
            </p>
          </div>
          <h2 className="max-w-[18ch] text-[clamp(3.5rem,8vw,8rem)] font-black leading-[0.86] tracking-[-0.05em] text-brand-white" data-id="element-234" data-mp="iu7v169v2z79">
            ABIE.
          </h2>
        </div>

        <div className="grid grid-cols-4 border-t border-white/15 max-[1040px]:grid-cols-2 max-[640px]:grid-cols-1" data-id="element-235" data-mp="slkn9yzknrdt">
          {pillars.map(pillar => <div key={pillar.num} className="border-b border-r border-white/15 p-[clamp(32px,4vw,50px)_clamp(24px,2.5vw,32px)] last:border-r-0 max-[1040px]:[&:nth-child(2n)]:border-r-0 max-[1040px]:[&:nth-last-child(-n+2)]:border-b-0 max-[640px]:!border-r-0 max-[640px]:border-b max-[640px]:last:border-b-0" data-id="element-236" data-mp="11m91atoytrqp">
              <span className="mb-[22px] block font-mono text-[12px] uppercase tracking-[0.18em] text-white/70" data-id="element-237" data-mp="37h1bzmyhair4">
                {pillar.num}
              </span>
              <h3 className="mb-[18px] text-[clamp(2.15rem,3.5vw,3.75rem)] font-black leading-none tracking-[-0.04em]" data-id="element-238" data-mp="3hd4p1nuvc1su">
                {pillar.title}
              </h3>
              <p className="max-w-[28ch] text-[15px] leading-[1.5] text-white/85" data-id="element-239" data-mp="3qem02rtf5dao">
                {pillar.desc}
              </p>
            </div>)}
        </div>

        <p className="mt-10 text-center text-[clamp(1.35rem,2.4vw,2.25rem)] font-black tracking-[-0.03em] text-white" data-id="element-240" data-mp="3ldetux6xcm64">
          Achieve It. Believe It. Innovate It. Elevate It.
        </p>
      </Container>
    </section>;
}